import React from 'react';
import { GiftIcon } from 'lucide-react';
import { CONSTANTS } from '../utils/constants';
import { scrollToOffer } from '../utils/scroll';
export const BonusSection: React.FC = () => {
  const bonuses = [{
    num: 1,
    title: '50 Sesiones Listas',
    desc: 'Sesiones completas que copiás directo a tu planificación.',
    img: CONSTANTS.IMAGES.BONUS_1
  }, {
    num: 2,
    title: 'Sistema Inteligente',
    desc: 'El método para diseñar entrenamientos que progresan.',
    img: CONSTANTS.IMAGES.BONUS_2
  }, {
    num: 3,
    title: 'Planes y Tácticas',
    desc: 'Esquemas tácticos, formaciones, estrategias específicas.',
    img: CONSTANTS.IMAGES.BONUS_3
  }, {
    num: 4,
    title: 'Errores y Ejercicios',
    desc: 'Los 20 errores más comunes + ejercicios correctivos.',
    img: CONSTANTS.IMAGES.BONUS_4
  }, {
    num: 5,
    title: 'Plan Semanal',
    desc: 'Plantillas semanales con distribución de cargas.',
    img: CONSTANTS.IMAGES.BONUS_5
  }, {
    num: 6,
    title: 'Guía desde Cero',
    desc: 'El paso a paso para crear tus propios planes.',
    img: CONSTANTS.IMAGES.BONUS_6
  }];
  return <section className="py-14 px-4 bg-blue-900 text-white" data-id="element-17">
      <div className="max-w-6xl mx-auto" data-id="element-18">
        <div className="text-center mb-12" data-id="element-19">
          <h2 className="text-3xl md:text-4xl font-bold mb-3" data-id="element-20">
            Además, hoy te llevás estos 6 BONOS GRATIS
          </h2>
          <p className="text-lg text-blue-200" data-id="element-21">
            Valorados en ${CONSTANTS.PRICING.BONUS_VALUE * 6} — Tuyos gratis con
            el Megapack
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10" data-id="element-22">
          {bonuses.map(bonus => <div key={bonus.num} onClick={scrollToOffer} className="bg-white rounded-xl overflow-hidden flex flex-col cursor-pointer transform transition-transform hover:-translate-y-1 hover:shadow-xl group border border-gray-100" data-id="element-23">
              <div className="w-full p-5 flex flex-col justify-center relative" data-id="element-24">
                <div className="absolute top-3 right-3 bg-red-600 text-white text-[10px] font-bold px-2 py-1 rounded-full uppercase tracking-wider shadow-sm" data-id="element-25">
                  GRATIS
                </div>
                <div className="flex items-center gap-2 text-orange-500 font-bold mb-2" data-id="element-26">
                  <GiftIcon className="w-5 h-5" data-id="element-27" />
                  <span className="text-base" data-id="element-28">BONUS {bonus.num}</span>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-1 group-hover:text-blue-600 transition-colors" data-id="element-29">
                  {bonus.title}
                </h3>
                <p className="text-gray-600 mb-3 text-sm leading-snug" data-id="element-30">
                  {bonus.desc}
                </p>
                <div className="mt-auto flex items-center gap-2 pt-3 border-t border-gray-100" data-id="element-31">
                  <span className="text-gray-400 line-through text-xs" data-id="element-32">
                    ${CONSTANTS.PRICING.BONUS_VALUE}
                  </span>
                  <span className="text-green-600 font-black text-base" data-id="element-33">
                    GRATIS
                  </span>
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-34">
          <button onClick={scrollToOffer} className="bg-orange-500 hover:bg-orange-600 text-white text-lg md:text-xl font-bold py-4 px-8 rounded-full shadow-[0_0_20px_rgba(249,115,22,0.4)] hover:shadow-[0_0_30px_rgba(249,115,22,0.6)] transition-all" data-id="element-35">
            Quiero el Megapack + Los 6 Bonos Gratis
          </button>
        </div>
      </div>
    </section>;
};